import {User} from '@/models/User';

export default {
    /**
     * Removes Fax User from given array
     *
     * @param {any[]} list
     * @returns
     */
    _removeFaxUserFromList(list: any[]) {
        for (let index = 0; index < list.length; index++) {
            if (list[index].familyName === 'FaxUser' && list[index].firstName === 'Fax') {
                list.splice(index, 1);
            }
        }
    },

    /**
     * Finds Fax User from given array
     *
     * @param {any[]} list
     * @returns faxUser if found
     */
    _findFaxUserFromList(list: any[]): User | null {
        for (const listElement of list) {
            if (listElement.familyName === 'FaxUser' && listElement.firstName === 'Fax') {
                return listElement;
            }
        }
        return null;
    },

    /**
     * Removes Fax User from assignable users array
     *
     * @param {any[]} list
     * @returns
     */
    _removeFaxUserFromAssignableUsersList(list: any[]) {
        for (let index = 0; index < list.length; index++) {
            if (list[index].lastname === 'FaxUser' && list[index].firstname === 'Fax') {
                list.splice(index, 1);
            }
        }
    },
};
